import { permissionSchema } from '@billing/validation/permission';

export interface Permission {
  id: string;
  resource: string;
  action: string;
}

export const isPermission = (obj: any): obj is Permission => {
  return permissionSchema.safeParse(obj).success;
};
